<template>
  <div class="rv-page">
    <div class="rv-container">
      <BModal ref="med-record" size="xl" hide-footer hide-header>
        <MedicalRecord :record-data="recordData" />
      </BModal>

      <div class="rv-grid">
        <!-- Video preview -->
        <div class="rv-video-col">
          <div class="rv-video-card">
            <video
              ref="camera"
              id="preview"
              width="100%"
              height="auto"
              autoPlay
              class="rv-video-el"
            />
            <div v-if="videoMuted || audioMuted" class="rv-video-msg">
              <p v-if="videoMuted">A sua câmera está desligada!</p>
              <p v-if="audioMuted">O seu microfone está desligado!</p>
            </div>
            <div class="rv-video-controls">
              <button
                v-if="!videoMuted"
                class="rv-ctrl-btn"
                @click.prevent="muteVideo"
              >
                <b-icon-camera-video class="b-icon-camera-button" />
              </button>
              <button
                v-else
                class="rv-ctrl-btn rv-ctrl-btn--muted"
                @click.prevent="unmuteVideo"
              >
                <b-icon-camera-video-off class="b-icon-camera-video-off" />
              </button>
              <button
                v-if="!audioMuted"
                class="rv-ctrl-btn"
                @click.prevent="muteAudio"
              >
                <b-icon-mic class="b-icon-mic" />
              </button>
              <button
                v-else
                class="rv-ctrl-btn rv-ctrl-btn--muted"
                @click.prevent="unmuteAudio"
              >
                <b-icon-mic-mute class="b-icon-mic-mute" />
              </button>
            </div>
          </div>
        </div>

        <!-- Info card -->
        <div class="rv-info-col">
          <div class="rv-info-card">
            <div v-if="isDoctor" class="rv-patient-row">
              <div class="rv-patient-avatar">
                <img :src="photoFallback()" alt="" class="rv-patient-img" />
              </div>
              <span class="rv-patient-name">{{ room.patient.name }}</span>
              <div class="rv-patient-actions">
                <button class="rv-action-btn" @click="showModal">
                  Ficha médica
                </button>
                <button
                  class="rv-action-btn"
                  data-testid="prescription-button"
                  :aria-busy="isOpeningPrescription ? 'true' : 'false'"
                  @click="showPlataformaPrescricao"
                >
                  {{ prescriptionButtonLabel }}
                </button>
              </div>
            </div>

            <h2 class="rv-title">A sala está pronta</h2>

            <div class="rv-url-group">
              <span class="rv-url-label">URL da sua consulta:</span>
              <div class="rv-url-row">
                <input
                  class="rv-url-input"
                  type="text"
                  :value="roomLink"
                  readonly
                />
                <button
                  class="rv-url-copy-btn"
                  type="button"
                  @click="copyToClipboard"
                  title="copiar"
                >
                  <img src="../assets/images/link-icon.svg" alt="copiar" />
                </button>
              </div>
              <span v-if="linkUrlCopied" class="rv-url-copied">
                <img src="../assets/images/check-icon.svg" alt="" />
                Copiado!
              </span>
            </div>

            <div class="rv-actions">
              <button
                :disabled="!canJoinRoom"
                class="btn btn--accent btn--lg"
                style="flex:1"
                @click="joinMeetingRoom(room)"
              >
                Entrar na consulta
              </button>
              <button
                class="btn btn--ghost btn--lg"
                style="color:rgba(255,255,255,.6);flex:1"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>

      <Loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
  </div>
</template>

<script>
import {
  roomMethods,
  userComputed,
  userMethods,
  faceRecognitionMethods
} from "./../state/helpers";
import { connect, createLocalVideoTrack } from "twilio-video";
import MedicalRecord from "../components/MedicalRecord";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Compressor from "compressorjs";
import { isDoctor } from "../utils/userRole";
import { ensureMemedSdk, memedMessageFor } from "../utils/memed";
import { resolveMemedToken } from "../utils/memedToken";
import dePara from "@/utils/drugs";

export default {
  name: "RoomView",
  components: {
    MedicalRecord,
    Loading
  },
  data() {
    return {
      murilo: false,
      takePhotoInterval: null,
      faceRecognitionAlert: true,
      doctorValidated: true,
      sendingPhoto: false,
      photo: "",
      audioMuted: false,
      videoMuted: false,
      room: { patient: { name: "", photo: "" } },
      roomInstance: {},
      localTracks: {},
      linkUrlCopied: false,

      recordData: {
        symptoms: [],
        patient: {},
        observation: undefined,
        last_appointment: null
      },

      loading: false,
      gotDevices: false,

      cameraRef: null,
      camera: {
        blob: null,
        devices: [],
        constraints: { audio: true, video: { width: 555, height: 367 } },
        selected: null,
        disableButton: false,
        capturedImages: []
      },
      memedPatient: null,
      prescriptionListenerReady: false,
      memedHub: null,
      isOpeningPrescription: false
    };
  },

  mounted() {
    this.getRoomDetailsV2(this.$route.params.room).then(response => {
      this.room = response.data;
      this.showSymptoms({ id: response.data.patient.id })
        .then(response => {
          this.memedPatient = response.data.user;
        })
        .catch(error => console.log(error));
    });
    this.cameraRef = this.$refs.camera;
    this.startCam();
  },

  updated() {
    if (this.linkUrlCopied) {
      setTimeout(() => {
        this.linkUrlCopied = false;
      }, 10000);
    }
  },

  destroyed() {
    this.stopCam();
  },

  methods: {
    ...roomMethods,
    ...userMethods,
    ...faceRecognitionMethods,

    startCam() {
      var constraints = { video: { width: 555, height: 367 } };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function(mediaStream) {
          var video = document.querySelector("video");
          video.srcObject = mediaStream;
          video.onloadedmetadata = function(e) {
            video.play();
          };
        });
    },
    stopCam() {
      if (this.cameraRef && this.cameraRef.srcObject) {
        this.cameraRef.srcObject.getVideoTracks().map(stream => stream.stop());
      }
    },
    muteAudio() {
      if (this.cameraRef && this.cameraRef.srcObject) {
        this.cameraRef.srcObject.getAudioTracks().map(stream => stream.stop());
      }
      this.audioMuted = true;
    },

    unmuteAudio() {
      this.audioMuted = false;
    },

    muteVideo() {
      this.videoMuted = true;
      this.stopCam();
    },
    unmuteVideo() {
      this.videoMuted = false;
      this.startCam();
    },

    copyToClipboard() {
      navigator.clipboard.writeText(this.roomLink);
      this.linkUrlCopied = true;
    },
    showModal(data) {
      this.showSymptoms({ id: this.room.patient.id }).then(response => {
        this.recordData.symptoms = response.data.symptoms;
        this.recordData.patient = response.data.user;
        this.recordData.observation = response.data.observation;
        this.recordData.last_appointment = response.data.last_appointment;
        this.loading = false;
        this.$refs["med-record"].show();
      });
    },

    photoFallback() {
      return (
        this.room.patient.photo || require("../assets/images/doctor-img.jpg")
      );
    },
    joinMeetingRoom(room) {
      this.$router.push({
        name: "MeetingRoomView",
        params: {
          room: room.id,
          audioMuted: this.audioMuted,
          videoMuted: this.videoMuted
        }
      });
    },
    takePhoto() {
      let that = this;

      navigator.mediaDevices.getUserMedia({ video: true }).then(mediaStream => {
        const track = mediaStream.getVideoTracks()[0];
        let imageCapture = new ImageCapture(track);
        imageCapture.takePhoto().then(blob => {
          const compressor = new Compressor(blob, {
            quality: 0.2,
            height: 540,
            width: 960,
            success(result) {
              var reader = new FileReader();
              reader.readAsDataURL(result);
              reader.onloadend = function() {
                that.photo = reader.result;
              };
            }
          });
        });
      });
    },
    // O SDK da Memed é carregado AQUI, no clique, e não mais no login: ele
    // instala iframes e um listener global de `message` no documento, então
    // não pode subir em telas que não vão prescrever.
    async ensurePrescriptionSdk() {
      const token = await resolveMemedToken(this.$store.state.user.currentUser);
      this.memedHub = await ensureMemedSdk(token);
      return this.memedHub;
    },

    registerPrescriptionListener() {
      if (this.prescriptionListenerReady || !this.memedHub) return;

      this.memedHub.event.add("prescricaoImpressa", prescriptionData => {
        const data = {
          prescription: {
            appointment_id: this.room.appointment_id,
            lme: prescriptionData.prescricao.lme,
            memed_id: prescriptionData.prescricao.id,
            signed: prescriptionData.prescricao.signed,
            drugs_attributes: dePara(prescriptionData.prescricao.medicamentos)
          }
        };
        return this.$store.dispatch("prescriptions/postPrescription", data);
      });

      this.prescriptionListenerReady = true;
    },
    async showPlataformaPrescricao() {
      // O botão continua sempre habilitado; a guarda é só contra clique duplo
      // enquanto o SDK carrega.
      if (this.isOpeningPrescription) return;
      this.isOpeningPrescription = true;

      try {
        await this.ensurePrescriptionSdk();
        this.registerPrescriptionListener();
        await this.sendPrescriptionCommands();
      } catch (error) {
        this.$toast.error(memedMessageFor(error));
      } finally {
        this.isOpeningPrescription = false;
      }
    },
    sendPrescriptionCommands() {
      return this.memedHub.command
        .send("plataforma.prescricao", "setPaciente", {
          nome: this.memedPatient.name,
          telefone: this.memedPatient.phone_number,
          dificuldade_locomocao: true,
          idExterno: this.memedPatient.id
        })
        .then(() => {
          this.memedHub.command.send(
            "plataforma.prescricao",
            "setFeatureToggle",
            {
              deletePatient: false,
              removePatient: false,
              editPatient: false
            }
          );
          this.memedHub.module.show("plataforma.prescricao");
        });
    }
  },
  computed: {
    ...userComputed,
    // Sem o preload do login o SDK leva um instante para subir; sem sinal no
    // botão o médico clica de novo achando que travou.
    prescriptionButtonLabel() {
      return this.isOpeningPrescription ? "Carregando…" : "Prescrição médica";
    },

    isDoctor() {
      return isDoctor(this.currentUser);
    },
    roomLink() {
      return `${window.location.href}`;
    },
    faceRecognitionStatus() {
      if (!this.doctorValidated && this.sendingPhoto)
        return "Validando informação";
      if (!this.doctorValidated)
        return "Favor olhar para webcam por alguns segundos enquanto fazemos uma validação de segurança.";

      return "Dados validados, boa consulta!";
    },
    showRecognizeAlert() {
      return this.faceRecognitionAlert && this.isDoctor && !this.videoMuted;
    },
    canJoinRoom() {
      if (this.isDoctor) return this.doctorValidated;
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.rv-page {
  min-height: calc(100vh - 80px);
  background: #0f172a;
  padding: 2.5rem 0;
  color: #fff;
}

.rv-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;

  @media (max-width: 576px) {
    padding: 0 16px;
  }
}

.rv-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
}

// -- Video column --
.rv-video-card {
  position: relative;
  background: #111827;
  border-radius: var(--radius-xl, 16px);
  overflow: hidden;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rv-video-el {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.rv-video-msg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 1rem;
  pointer-events: none;

  p {
    margin: 4px 0;
  }
}

.rv-video-controls {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
}

.rv-ctrl-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: 1.5px solid rgba(255, 255, 255, 0.25);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.28);
  }

  &--muted {
    background: rgba(220, 38, 38, 0.85);
    border-color: transparent;

    &:hover {
      background: rgba(220, 38, 38, 1);
    }
  }
}

// -- Info column --
.rv-info-card {
  background: rgba(255, 255, 255, 0.06);
  border-radius: var(--radius-xl, 16px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: #fff;
}

.rv-patient-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--color-gray-100, #f1f5f9);
  flex-wrap: wrap;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.rv-patient-avatar {
  flex-shrink: 0;
}

.rv-patient-img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--color-gray-200, #e2e8f0);
}

.rv-patient-name {
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 1rem;
  font-weight: var(--fw-bold, 700);
  color: #fff;
  flex: 1;
}

.rv-patient-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.rv-action-btn {
  padding: 6px 14px;
  background: #fff;
  border: 1.5px solid var(--color-gray-300, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 0.8125rem;
  font-weight: var(--fw-semibold, 600);
  color: var(--color-gray-600, #475569);
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;

  &:hover {
    border-color: var(--color-gray-500, #64748b);
    color: var(--color-gray-800, #1e293b);
  }
}

.rv-title {
  margin: 0;
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 1.25rem;
  font-weight: var(--fw-bold, 700);
  color: #fff;
  letter-spacing: -0.3px;
}

.rv-url-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rv-url-label {
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 0.875rem;
  font-weight: var(--fw-semibold, 600);
  color: rgba(255, 255, 255, 0.6);
}

.rv-url-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rv-url-input {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border: 1.5px solid rgba(255, 255, 255, 0.15);
  border-radius: var(--radius-md, 8px);
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: rgba(255, 255, 255, 0.08);
  outline: none;
  transition: border-color 0.15s;

  &:focus {
    border-color: var(--color-primary, #1a6cf7);
  }
}

.rv-url-copy-btn {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1.5px solid var(--color-gray-200, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  cursor: pointer;
  transition: border-color 0.15s;

  &:hover {
    border-color: var(--color-gray-400, #94a3b8);
  }
}

.rv-url-copied {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 0.8125rem;
  font-weight: var(--fw-semibold, 600);
  color: var(--color-primary, #1a6cf7);
}

.rv-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    flex-direction: column;
  }
}

.rv-btn {
  flex: 1;
  padding: 12px 20px;
  border-radius: var(--radius-md, 8px);
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 0.9375rem;
  font-weight: var(--fw-bold, 700);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  border: 1.5px solid transparent;
  text-align: center;

  &--primary {
    background: var(--color-primary, #1a6cf7);
    color: #fff;
    border-color: var(--color-primary, #1a6cf7);

    &:hover:not(:disabled) {
      background: #155fd4;
      border-color: #155fd4;
    }

    &:disabled,
    &.rv-btn--disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &--secondary {
    background: #fff;
    color: var(--color-gray-600, #475569);
    border-color: var(--color-gray-300, #cbd5e1);

    &:hover {
      border-color: var(--color-gray-500, #64748b);
      color: var(--color-gray-800, #1e293b);
    }
  }
}
</style>
